import { render, staticRenderFns } from "./StringsLayout.vue?vue&type=template&id=66e85827"
import script from "./StringsLayout.vue?vue&type=script&lang=js"
export * from "./StringsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports